import React from 'react';
import { useNavigate } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import './UnitWorld.scss';

function UnitWorld({ unlocked, worldImage, path, title }) {
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const Lock = login.cloudFront + 'images/Images/Icon_Lock_Large_white.png' + login.cookie;
  
  const handleWorldClick = (unlocked, unitRoute) => {
    if (unlocked) navigate(unitRoute);
  };

  const navigate = useNavigate();

  return (
    <div className={`unit-world ${unlocked ? 'active' : ''}`}>
      <figure>
        {/* Lock Image */}
        {!unlocked && (
          <img className='unit-world__lock' src={Lock} alt='Lock' />
        )}

        <img
          src={worldImage}
          className='unit-world__image'
          alt={title}
          onClick={() => handleWorldClick(unlocked, path)}
        />
      </figure>
      <div className='unit-world__title'>
        <h3>{title}</h3>
      </div>
    </div>
  );
}

export default UnitWorld;
